export default {
    // User 账户： 
    getAccountPage: "/account/getAccountPage",
    // User 管理员修改密码
    editPassword: "/account/editPassword",
    // user 管理员修改用户密码
    getEditPasswordAdmin: "/account/editPasswordAdmin",
    // 更新用户信息
    getUpdateAccount: "/account/updateAccount",
     // 更新用户信息
      getUpdateAccountStatus: "/account/updateAccountActive",
    // user 根据accountID 获取角色详情
    getAccountDetail: "/account/getAccountDetail",
    // user 新增用户
    getSaveAccount: "/account/saveAccount",
    // user 获取work office 列表
    getOfficeList: "/account/getOfficeList",
    // user 获取role list 列表
    getOldRoleList: "/account/getOldRoleList",
    //  根据ID获取已分配的角色
    getAccountListByRoleId: "/account/getAccountListByRoleId",
    // 根据角色ID 获取未分配的角色
    getAccountOtherListByRoleId: "/account/getAccountOtherListByRoleId",
    //根据角色ID 删除绑定角色
    getAccountDel:"/account/delAccountRoleAssociationBatch",
    // 角色人员关联 
    getsaveAssociation: "/account/saveAssociation",
    // 获取companylist
    getCompanyList: "/account/getCompanyList",
    // 获取OwnerList
    getOwnerList: "/account/getOwnerList",
    // 获取Trust
    getTrustList: "/account/getTrustList",
    // 获取grouup
    getGroupList: "/account/getGroupNameList",
    // 获取prop
    getPropList: "/account/getPropList",
    // 根据accountid 新增角色修改
    getSaveOrUpdateAccountRole: "/account/saveOrUpdateAccountRole",
    //  角色关联菜单
    getSaveRoleMenu:"/account/saveRoleMenuPermission",
    // NON account 获取人员数据
    searchAccountType: "/account/searchAccount",
    // 根据token获取用户名称
    getNameStr: "/account/getNameStr",
    // 修改人员查看合同查看contract 数据权限
    getUpdateAccountContract:"/account/updateAccountContract",
    // 控制登录app
    updateEnableApp:"/account/updateEnableApp",
    // 获取人员权限信息
    getRoleMenuByAccountId: "/role/getRoleMenuByAccountId",
    // 根据accountld删除用户
    delAccount: "/account/delAccount"
}